var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.56 20.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-A2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.9,8.49H3.8a.9.9,0,0,1,.9.9V19.76a.9.9,0,0,1-.9.89H.9a.89.89,0,0,1-.9-.89V9.39A.9.9,0,0,1,.9,8.49Z",
    transform: "translate(0 0)",
    fill: "gray",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33,3.9h2.91a.9.9,0,0,1,.89.9v15a.9.9,0,0,1-.89.89H8.33a.9.9,0,0,1-.9-.89V4.8A.9.9,0,0,1,8.33,3.9Z",
    transform: "translate(0 0)",
    fill: "gray",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75,0h2.91a.9.9,0,0,1,.9.9V19.77a.9.9,0,0,1-.9.89H15.75a.9.9,0,0,1-.89-.89V.9A.9.9,0,0,1,15.75,0Z",
    transform: "translate(0 0)",
    fill: "gray",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/A2.301b479e28fa917b89e7b4ceda2f218a.svg";
export { ForwardRef as ReactComponent };